module.exports = __webpack_public_path__ + "img/Info.9905c5b1.svg";